export function SwapIcon() {
  return (
    <svg className="swap-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 17l4-4m0 0l-4-4m4 4H7"></path>
      <path d="M7 7l-4 4m0 0l4 4m-4-4h14"></path>
    </svg>
  );
}
